<template>
  <div>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex align-end justify-space-between">
        <v-btn
          small
          color="primary"
          class="white--text px-4"
          @click="dialog = true"
        >
          <v-icon left small>mdi-plus</v-icon>Add
        </v-btn>
      </v-col>
    </v-row>

    <PageTable
      :table-loading="tableLoading"
      :data-loaded="dataLoaded"
      :table-headers="tableHeaders"
      :table-items="roleParent"
      filter
      @show="show"
      @edit="edit"
      @remove="remove"
    />

    <RoleDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @saveRole="saveRole"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Are you sure that you want to delete this thing?`"
      @confirm="removeRole"
      @closeConfirmModal="closeDialog"
    />
  </div>
</template>

<script>
import { roleApi } from '@/api'
import { RoleParent } from '@/models'
import PageTable from '@/components/ui/Table'
import RoleDialog from '@/components/admin/role/Role'
import ConfirmDialog from '@/components/dialogs/Confirm'

export default {
  name: 'RoleParent',

  metaInfo: {
    title: 'Role'
  },

  components: {
    RoleDialog,
    PageTable,
    ConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getRoleParent()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Name', value: 'name', sortable: false, align: 'start' },
      { text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '130px' }
    ],
    roleParent: new RoleParent(),
    tableLoading: false,
    selectedItem: null,
    confirmDialog: false,
    dialog: false,
    isShowMode: false,
    btnLoading: false,
    dataLoaded: false
  }),

  methods: {

    async getRoleParent() {
        try {
        const data = await roleApi.getCatalog()
        if (data.length) data.forEach(obj => this.roleParent.addRole(obj))
      }
      catch (e) {
        this.showErrorMessage(e, 'Data loading error')
      }
    },

    async saveRole(body) {
      try {
        this.btnLoading = true

        const data = body.id ? await roleApi.update(body) : await roleApi.create(body)
        body.id ? this.roleParent.updateRole(data) : this.roleParent.addRole(data)
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeRole() {
      try {
        this.btnLoading = true

        await roleApi.remove(this.selectedItem.id)
        this.roleParent.removeRole(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  },

}
</script>

<style scoped>
</style>
